import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="image-preview"
export default class extends Controller {
  static targets = ["modal", "image"]

  connect() {
    // Close modal on escape key
    this.handleEscape = this.handleEscape.bind(this)
  }

  show(event) {
    event.preventDefault()
    const imageUrl = event.currentTarget.src
    const altText = event.currentTarget.alt || "Product image"
    
    // Create modal if it doesn't exist
    this.createModal(imageUrl, altText)
  }

  createModal(imageUrl, altText) {
    // Remove existing modal if any
    const existingModal = document.getElementById('image-preview-modal')
    if (existingModal) {
      existingModal.remove()
    }

    // Create modal HTML
    const modalHTML = `
      <div id="image-preview-modal" 
           class="fixed inset-0 z-50 overflow-y-auto" 
           aria-labelledby="modal-title" 
           role="dialog" 
           aria-modal="true"
           data-controller="image-preview">
        <div class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
          <!-- Background overlay -->
          <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity" 
               data-action="click->image-preview#close"
               aria-hidden="true"></div>

          <!-- Center modal contents -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

          <div class="inline-block align-middle bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-5xl sm:w-full relative">
            <!-- Close button -->
            <div class="absolute top-4 right-4 z-10">
              <button type="button" 
                      data-action="click->image-preview#close"
                      class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 p-2 shadow-lg">
                <span class="sr-only">Close</span>
                <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <!-- Image container -->
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6">
              <div class="flex items-center justify-center">
                <img src="${imageUrl}" 
                     alt="${altText}" 
                     class="max-w-full max-h-[80vh] object-contain rounded-lg">
              </div>
            </div>

            <!-- Footer with close button -->
            <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <button type="button" 
                      data-action="click->image-preview#close"
                      class="w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    `

    // Add modal to body
    document.body.insertAdjacentHTML('beforeend', modalHTML)
    
    // Prevent body scroll
    document.body.style.overflow = "hidden"
    
    // Add escape key listener
    document.addEventListener("keydown", this.handleEscape)
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }
    
    const modal = document.getElementById('image-preview-modal')
    if (modal) {
      modal.remove()
    }
    
    // Restore body scroll
    document.body.style.overflow = ""
    
    // Remove escape key listener
    document.removeEventListener("keydown", this.handleEscape)
  }

  handleEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  disconnect() {
    // Cleanup
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.handleEscape)
    const modal = document.getElementById('image-preview-modal')
    if (modal) {
      modal.remove()
    }
  }
}

